// $.urlParam = function(name) {
//     var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
//     if (results == null) {
//       return "";
//     } else {
//       return results[1] || 0;
//     }
//   }
  
//  // const getDiscountParam = decodeURIComponent($.urlParam('discount')); 
// const getDiscountParam = decodeURIComponent($.urlParam('discount'));
// const getDiscountSource = decodeURIComponent($.urlParam('utm_source'));  
// var appendDiscountParam = '';

// if ( getDiscountSource ==='Klaviyo' && getDiscountParam === 'bfcm20') { 
//   appendDiscountParam = '?discount=' + getDiscountParam;  
// } else {
//   console.log('Referrer is not from an email link.');
// }


// const bundleVariantID1 = '41445263212588' // outdoor adventure bundle $36
// const bundleVariantID2 = '41802575806508' // winter wellness bundle $36
// const bundleVariantID3 = '41812801945644' // tranquil nights bundle (The Bewitching Hours Survival Bundle) $36
// const bundleVariantID4 = '41812823539756' // The Stress Busting Bundle $36

// function returnShopNow1() {
//   window.location.href = '/cart/' + bundleVariantID1 + ':1' + appendDiscountParam;
// }

// function returnShopNow2() {
//   window.location.href = '/cart/' + bundleVariantID2 + ':1' + appendDiscountParam;
// }

// function returnShopNow3() {
//   window.location.href = '/cart/' + bundleVariantID3 + ':1' + appendDiscountParam;
// }

// function returnShopNow4() {
//   window.location.href = '/cart/' + bundleVariantID4 + ':1' + appendDiscountParam;
// }

//   $(document).ready(function() {
//       $(".shopify-section-group-header-group").remove(); 
//       $("body").addClass('black-friday-template');  
//   });

$.urlParam = function(name) {
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
  if (results == null) {
    return "";
  } else {
    return results[1] || 0;
  }
} 
const getDiscountParam = decodeURIComponent($.urlParam('discount'));
const getDiscountSource = decodeURIComponent($.urlParam('utm_source'));  
var appendDiscountParam = '';

if ( getDiscountSource ==='Klaviyo' && getDiscountParam === 'bfcm20') { 
  appendDiscountParam = '&discount=' + getDiscountParam;  
} else {
  console.log('Referrer is not from an email link.');
}

$(document).ready(function() {
    $(".shopify-section-group-header-group").remove(); 
    $("body").addClass('black-friday-template');   
    $('.bundles-container .btn').click(function(event) { 
      event.preventDefault(); 
      var getOriginalURL = $(this).attr('href'); 
      var newURLHref = getOriginalURL + appendDiscountParam; 
      window.location.href = newURLHref;
    });
});